// extracted by mini-css-extract-plugin
export default {"firstScreenRightCon":"firstScreenRightCon--Bd0NE","markerAnimationScale":"markerAnimationScale--a7drS"};